import { flushSync } from 'react-dom';
import {useState} from "react";

export const createRowSelectionHandler = ({
                                              selectedRowKeyRef,
                                              selectedRowIndexRef,
                                              rowRerenderTriggers
                                          }) => (newKey, newIndex) => {

    const prevKey = selectedRowKeyRef.current;
    if (prevKey === newKey) return;

    selectedRowKeyRef.current = newKey;
    selectedRowIndexRef.current = newIndex;

    // ✅ manually trigger local row rerenders
    rowRerenderTriggers.current.get(prevKey)?.();
    rowRerenderTriggers.current.get(newKey)?.();
};
